import { useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button } from "@mui/material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const AddEmailTemplateType = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const [name, setName] = useState<string>("");
    const [isItautomation, setIsItautomation] = useState<string>("Yes");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        setPleaseWaitPopup(true);
        e.preventDefault();

        await axios
            .post(
                `${baseURL}emailTemplateType?userId=${auth?.id}`,
                JSON.stringify({
                    name,
                    isItautomation: isItautomation === "Yes" ? true : false,
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                    withCredentials: true,
                }
            )
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Email Template Type</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Email Template Type Name</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Automation?</label>
                                                <select
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={isItautomation}
                                                    onChange={(e) => setIsItautomation(e.target.value)}
                                                >
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit"
                                            >
                                                Save
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>

    )
}